var MAX_MILLIS = 2000;
var waitUntil = function (predicate, errorMessage) {
    if (errorMessage === void 0) { errorMessage = "Predicate did not become true in " + MAX_MILLIS + "ms"; }
    var timedOut = false;
    var timeout = setTimeout(function () { return (timedOut = true); }, MAX_MILLIS);
    var recursivelyResolve = function (resolve, reject) {
        if (timedOut) {
            reject(errorMessage);
        }
        if (predicate()) {
            clearTimeout(timeout);
            resolve();
        }
        else {
            setTimeout(function () { return recursivelyResolve(resolve, reject); }, 10);
        }
    };
    return new Promise(function (resolve, reject) {
        recursivelyResolve(resolve, reject);
    });
};
export default waitUntil;
